<div class="page">
  <div class="app">
    <div class="app-header">
      <app-header></app-header>
    </div>

    <div class="app-body" (click)="closeNotifications($event)">
      <div class="app-sidebar" *ngIf="!hideNavBar">
        <app-sidebar></app-sidebar>
      </div>
      <mat-sidenav-container
        class="app-content"
        [ngClass]="{ 'no-navbar': hideNavBar }"
        hasBackdrop="false"
      >
        <mat-sidenav
          class="notifications-container"
          mode="over"
          position="end"
          [opened]="notificationsOpen"
          disableClose="false"
          (click)="$event.stopPropagation()"
          (scrolled)="onScrolled()"
          infiniteScroll
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="50"
          [scrollWindow]="false"
        >
          <div class="notifications">
            <div class="notification-header notification">
              <div class="left-info">
                <div class="heading">Notifications</div>
                <div *ngIf="notifications.length" class="options">
                  <button mat-button (click)="markAllRead()">
                    <svg-icon
                      src="assets/svg/checkmark-circle.svg"
                      [svgStyle]="{
                        'width.px': '21.5'
                      }"
                      svgClass="lightBlueBtn"
                    ></svg-icon>
                    <span class="text">Mark all read</span>
                  </button>
                  <button mat-button (click)="deleteAll()">
                    <svg-icon
                      src="assets/svg/trashcan.svg"
                      [svgStyle]="{
                        'width.px': '22.5',
                        'height.px': '22.298'
                      }"
                      svgClass="lightBlueBtn"
                    ></svg-icon>
                    <span class="text">Delete all </span>
                  </button>
                </div>
              </div>
              <div class="right-options">
                <button mat-icon-button (click)="notificationsOpen = false">
                  <svg-icon
                    src="assets/svg/x-circle.svg"
                    [svgStyle]="{
                      'width.px': '25'
                    }"
                    svgClass="removeNotificationHeader"
                    viewBox="auto"
                  ></svg-icon>
                </button>
              </div>
            </div>
            <div *ngIf="!notifications.length" class="no-notifications">
              <div class="text">No notifications to display</div>
            </div>
            <div
              class="notification"
              *ngFor="let notification of notifications"
              [ngClass]="{ viewed: notification.viewed }"
            >
              <button
                mat-button
                (click)="openNotification(notification)"
                class="notification-btn"
              >
                <div class="left-info">
                  <div class="date">{{ notification.date }}</div>
                  <div class="message">
                    {{ notification.message }}
                  </div>
                </div>
                <div class="right-options">
                  <div class="time">{{ notification.time }}</div>
                  <div class="delete">
                    <button
                      mat-button
                      (click)="deleteNotification($event, notification)"
                    >
                      <svg-icon
                        src="assets/svg/trashcan.svg"
                        [svgStyle]="{
                          'width.px': '22.5',
                          'height.px': '22.298'
                        }"
                        svgClass="lightBlueBtn"
                        viewBox="auto"
                      ></svg-icon>
                    </button>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </mat-sidenav>
        <mat-sidenav-content>
          <router-outlet></router-outlet>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </div>
</div>
